import { createContext, useContext, useState } from "react";

// Create a context
const AlertContext = createContext();

// Create a provider wrapper component
export const AlertProvider = ({ children, title, message, onConfirm }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isAlertLoading, setIsAlertLoading] = useState(false);

  function openAlert() {
    setIsOpen(true);
  }

  function closeAlert() {
    setIsOpen(false);
  }

  async function confirmAlert() {
    setIsAlertLoading(true);
    await onConfirm();
    closeAlert();
    setIsAlertLoading(false);
  }

  return (
    <AlertContext.Provider
      value={{ isOpen, openAlert, closeAlert, title, message, isAlertLoading, confirmAlert }}
    >
      {children}
    </AlertContext.Provider>
  );
};

// Create a custom hook that uses the context
export const useAlertContext = () => {
  const context = useContext(AlertContext);
  if (!context) throw new Error("useAlertContext must be used within a AlertProvider");
  return context;
};
